/**
 * Style-Score: Marktposition und Pricing-Realismus.
 *
 * Heuristik (Konzept §4.2 Dimension 3):
 *   - Basis 20
 *   - Zielgruppe definiert: +15, plus +5 wenn Beschreibung ≥ 30 Zeichen
 *   - mind. ein Wettbewerber benannt: +10
 *   - Differenzierung formuliert (≥ 30 Zeichen): +15
 *   - Pricing-Strategie dokumentiert: +10
 *   - Stundensatz-Logik:
 *       * unbekannt: 0
 *       * ≥ Branchenuntergrenze: +20
 *       * 80-99% der Untergrenze: +10
 *       * < 80% der Untergrenze: 0 (Risiko: separate Risk-Indicator)
 *     Falls keine Untergrenze gesetzt: +10 (neutrale Aussage).
 */
import type { ScoreValue } from '../schema/brands.js';
import type { StyleData } from '../schema/dimensionData.js';
import { clampScore } from './internal/clamp.js';

export function computeStyleScore(data: StyleData): ScoreValue {
  let score = 20;

  if (data.targetGroupDefined) {
    score += 15;
    if ((data.targetGroupDescription ?? '').trim().length >= 30) {
      score += 5;
    }
  }

  if (data.competitors.length >= 1) score += 10;

  if ((data.differentiators ?? '').trim().length >= 30) score += 15;

  if (data.pricingStrategyDocumented) score += 10;

  const own = data.selfReportedHourlyRateEuro;
  const floor = data.industryFloorHourlyRateEuro;
  if (typeof own === 'number') {
    if (typeof floor === 'number' && floor > 0) {
      const ratio = own / floor;
      if (ratio >= 1) score += 20;
      else if (ratio >= 0.8) score += 10;
      // <0.8 → 0 (gleichzeitig Risk-Indicator)
    } else {
      score += 10; // neutral, weil Branchenwert fehlt
    }
  }

  return clampScore(score);
}
